import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-select/dist/vue-select.css';
import Vue from 'vue';
import { DurationOption, ParsedResource } from '@bookings/interfaces/calendar';
import { BookingOptionExportObject, OptionGroupsStructure } from '@core/interfaces/option-group';
import { Discipline } from '@centers/interfaces/discipline';
import { SubscriptionCategory } from '@subscriptions/interfaces/subscription-category';
import { Resource } from '@centers/interfaces/resource';
import { extractOptions } from '@core/helpers/option-groups.helper';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

@Component({
  name: '',
  components: {},
})
export default class PublicOrganizationBookingFormCalendarOptions extends Vue {
  @Prop(Array) readonly initialResources: Resource[];

  selectedDate = new Date().toISOString().substr(0, 10);
  rawResources: Resource[] = []; // We store here all resources of the contact
  resources: ParsedResource[] = []; // Parsed resources of the contact.

  bookingOptions: OptionGroupsStructure = null; // We store here the result of the options requested to the API. Has a fixedOptions and variableOptions
  mergedBookingOptions: BookingOptionExportObject = null; // We store here the result of a merge between the fixedOptions and the variableOptions
  bookingOptionsLoaded: boolean = false;
  bookingOptionsSubscription = null; // Subscription object to control the request for get the booking options

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  /**
   * Functions for fill the selectors
   */
  async loadResources(): Promise<ParsedResource[]> {
    this.resetResources();
    if (this.initialResources) {
      this.rawResources = this.initialResources;
      this.resources = this.parseResources(this.initialResources);
    } else {
      const params = {
        per_page: -1,
        orderBy: 'ordering',
        orderDirection: 'asc',
        status: 'active',
        contact_id: this.currentContactId,
      };

      const config = { params };
      const res = await this.$bpcApi
        .get(this.$bpcApiRouteHelper.getEntityPath('resources'), config)
        .toPromise();
      this.rawResources = res.data;
      this.resources = this.parseResources(res.data);
    }

    return this.resources;
  }

  async loadBookingOptions() {
    this.resetBookingOptions();
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'option-groups',
      'raw',
    )}/for-entity`;

    const data = {
      entity_type: 'booking',
      fixed_attributes: [
        {
          entity_type: 'center_settings',
          id: this.getTenantId,
        },
      ],
      variable_attributes: {
        contacts: [{ entity_type: 'contacts', id: this.currentContactId }],
        resources: this.resources.map(resource => {
          return { entity_type: 'resources', id: resource.id };
        }),
      },
    };
    const observable: Observable<BPCGenericApiResponse> = await this.$bpcApi.post(
      fetchEntityPath,
      data,
    );

    if (this.bookingOptionsSubscription) {
      this.bookingOptionsSubscription.unsubscribe();
    }

    this.bookingOptionsSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        if (res.data) {
          this.bookingOptionsLoaded = true;
          this.bookingOptions = res.data;
          this.mergedBookingOptions = res.data.fixed_options;
        }
      },
      error => {
        console.log(error);
      },
    );
  }

  /**
   * Aux computed attributes
   */
  get currentContactId(): number {
    return this.$authService.getContactId();
  }
  get getTenantId(): void {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  /**
   * Aux functions
   */
  parseResources(resources: Resource[]) {
    return resources.map(resource => {
      return {
        id: `${resource.id}`,
        title: resource.code,
        name: resource.name,
        ordering: resource.ordering,
      };
    });
  }
  resetBookingOptions() {
    this.bookingOptionsLoaded = false;
    this.bookingOptions = null;
    this.mergedBookingOptions = null;
    this.bookingOptionsSubscription = null;
  }
  resetResources() {
    this.resources = [];
  }
  async getAllEvents() {
    console.log('getAllEvents');
  }
  async getSlotPricesCategories() {
    console.log('getSlotPricesCategories');
  }
  checkSlotsAvailability() {
    console.log('checkSlotsAvailability');
  }
}
